// value is used to determine sort order of errors in location targets list
export const LocationTargetErrorType = {
  UNSUPPORTED_LOCATION: 1,
  REDUNDANT_LOCATION: 2,
  FACEBOOK_AND_GOOGLE_NOT_SUPPORTED: 3,
  GOOGLE_NOT_SUPPORTED: 4,
  FACEBOOK_NOT_SUPPORTED: 5,
  THIRD_PARTY_NOT_SUPPORTED: 6,
  AUDIENCE_REQUIRED_MIN_RADIUS: 7,
  AUDIENCE_REQUIRED_POSTAL_CODE_NOT_SUPPORTED: 8,
  FACEBOOK_CALL_EXTENSION_COUNTRY_LIMITED_TARGET: 9,
};
